import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { iframeUrl } from 'src/app/core/constant/iframeUrls';

@Component({
  selector: 'app-entity-search',
  templateUrl: './entity-search.component.html',
  styleUrls: ['./entity-search.component.scss']
})
export class EntitySearchComponent implements OnInit {
  iframeUrlSearchEntity: any;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    let iframeUrlSearchEntityRaw = iframeUrl.entitySearch.url;
    this.iframeUrlSearchEntity = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrlSearchEntityRaw);
  }

  BackToDashboard() {
    this.router.navigate(['dashboard']);
  }

}
